module.exports = __webpack_public_path__ + "img/fiveB.b84ea563.png";